export default __webpack_public_path__ + "static/media/user.71ad2b4e.svg";